import { isFunction } from "lodash-es";

import { navigate } from "../navigation/location";

export const SubmitAction = Symbol("SubmitAction");

export class StatefullUrl<S> {
    constructor(
        readonly url: string,
        readonly state: S,
    ) {}
}

export type Action = (() => unknown) | string | StatefullUrl<any> | typeof SubmitAction;

export function getActionAnchorProps(action: Action | undefined): { href?: string } {
    if (typeof action === "string") {
        return { href: action };
    }
    return {};
}

export function getActionClickableProps(action: Action | undefined): { onClick?: () => unknown } {
    if (isFunction(action)) {
        return { onClick: action };
    }
    if (action instanceof StatefullUrl) {
        return {
            onClick: () => {
                navigate(action.url, { state: action.state });
            },
        };
    }
    return {};
}

export function getActionButtonProps(action: Action | undefined): { type: "submit" | "button" } {
    if (action === SubmitAction) {
        return { type: "submit" };
    }
    return { type: "button" };
}
